<template>
  <div id="gallery">
    <v-container>
     <sectionTitle :title="title" />
        <PicGallery/>
    </v-container>     
  </div>
</template>

<script>
    import sectionTitle from "@/components/SectionTitle";
    import PicGallery from "@/components/PicGallery";

    export default {
        name: 'Gallery',
        components: { sectionTitle, PicGallery },
        data() {
           return {
              title: 'Галерея'
                                                                                     
           }
        }
    }
</script>


<style>
     #gallery {
       background-color: #eee!important;
     }
    .pic-gallery .thumb {
      padding: 2px;
      background-color: black;
      border-radius: 5px!important;
    }
</style>

